import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { getUserAsAdmin } from '../../../../services/user';

import './style.scss';

const AddedElections = (props) => {
  const {
    adminApproveElection,
    adminUnapproveElection,
    approvedElections,
    getAllApprovedElections,
    getAllUnapprovedElections,
    unapprovedElections,
  } = props;

  const [foundUsers, setFoundUsers] = useState([]);

  useEffect(() => {
    getAllApprovedElections();
    getAllUnapprovedElections();
  }, []);


  useEffect(() => {
    (async () => {
      const userIds = [...new Set([
        ...approvedElections.map(election => election.created_by),
        ...approvedElections.map(election => election.admin_approved_id),
        ...unapprovedElections.map(election => election.created_by),
      ])];

      const users = await Promise.all(userIds.map(id => getUserAsAdmin(id)));

      setFoundUsers(users.reduce((acc, curr) => ({
        ...acc,
        [curr._id]: curr,
      }), {}));
    })();
  }, [approvedElections, unapprovedElections]);

  return (
    <div id="admin-content">
      <h1>Admin Portal</h1>
      <Link className="admin-home-button" to="/admin">Go To Admin Home</Link>
      <div className="admin-container list-container">
        <h3>Unapproved Elections</h3>
        <ul>
          {unapprovedElections.map(election => (
            <li key={election._id}>
              <p>Title: {election.title}</p>
              <p>State: {election.state}</p>
              <p>Date: {election.date}</p>
              <p>Races: {JSON.stringify(election.races)}</p>
              <p>Reported By: {foundUsers[election.created_by] ? `${foundUsers[election.created_by].first_name} ${foundUsers[election.created_by].last_name}` : election.created_by}</p>
              <button type="button" onClick={() => adminApproveElection(election._id)}>Approve Election</button>
            </li>
          ))}
        </ul>
      </div>
      <div className="admin-container list-container">
        <h3>Approved Elections</h3>
        <ul>
          {approvedElections.map(election => (
            <li key={election._id}>
              <p>Title: {election.title}</p>
              <p>State: {election.state}</p>
              <p>Date: {election.date}</p>
              <p>Races: {JSON.stringify(election.races)}</p>
              <p>Reported By: {foundUsers[election.created_by] ? `${foundUsers[election.created_by].first_name} ${foundUsers[election.created_by].last_name}` : election.created_by}</p>
              <p>Approved By: {foundUsers[election.admin_approved_id]
                ? `${foundUsers[election.admin_approved_id].first_name} ${foundUsers[election.admin_approved_id].last_name}` : election.admin_approved_id}
              </p>
              <button type="button" onClick={() => adminUnapproveElection(election._id)}>Un-Approve Election</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AddedElections;
